<ng-container *ngIf="model">
  <div *ngIf="model.canDismiss" class="panel panel-primary">
    <div class="panel-body">
      <app-dismiss-form [status]="status">
        <ng-container headerTitle>
          {{"alert.form.title." + (Constants.SUSPICIOUS_CONFIGURATION_CHANGE == model.type ? "suspiciousConfigurationChange" : "suspiciousAccess") | translate : { response: "alert.form.title.unknown" } }}
        </ng-container>
        <ng-container headerIcon>
          <img src="assets/images/unknown_black.png" height="20" width="20" />
        </ng-container>
      </app-dismiss-form>
    </div>
  </div>
</ng-container>